// import React, { useState } from "react";
// import swal from "sweetalert";
// import { useNavigate } from "react-router-dom";

// const ForgotPasswordPage = () => {
//   const [email, setEmail] = useState("");
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleForgotPassword = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const response = await fetch("http://127.0.0.1:5055/api/users/forgot-password", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email }),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         swal("Success", "Password reset token sent. Check your email.", "success");
//         navigate(`/reset-password?token=${data.reset_token}`);
//       } else {
//         swal("Error", data.error || "Failed to send reset link", "error");
//       }
//     } catch (err) {
//       swal("Error", "Server error during forgot password", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.background}>
//         <div style={styles.shape}></div>
//         <div style={styles.shape}></div>
//       </div>
      
//       <form onSubmit={handleForgotPassword} style={styles.form}>
//         <h2 style={styles.title}>Forgot Password?</h2>
//         <p style={styles.subtitle}>Enter your email address and we'll send you a reset link</p>
        
//         <div style={styles.inputGroup}>
//           <input
//             type="email"
//             placeholder="Enter your registered email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             required
//             style={styles.input}
//             disabled={loading}
//           />
//           <span style={styles.inputIcon}>📧</span>
//         </div>

//         <button 
//           type="submit" 
//           disabled={loading}
//           style={{
//             ...styles.button,
//             ...(loading ? styles.buttonDisabled : {})
//           }}
//         >
//           {loading ? (
//             <div style={styles.loadingContent}>
//               <div style={styles.spinner}></div>
//               Sending Reset Link...
//             </div>
//           ) : (
//             "Send Reset Link"
//           )}
//         </button>

//         <button 
//           type="button" 
//           onClick={() => navigate('/login')}
//           style={styles.backButton}
//         >
//           ← Back to Login
//         </button>
//       </form>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     minHeight: '100vh',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//     padding: '20px',
//     position: 'relative',
//     overflow: 'hidden'
//   },
//   background: {
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     zIndex: 1
//   },
//   shape: {
//     position: 'absolute',
//     borderRadius: '50%',
//     background: 'rgba(255, 255, 255, 0.1)'
//   },
//   form: {
//     backgroundColor: 'rgba(255, 255, 255, 0.95)',
//     padding: '40px',
//     borderRadius: '20px',
//     boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
//     width: '100%',
//     maxWidth: '400px',
//     textAlign: 'center',
//     backdropFilter: 'blur(10px)',
//     border: '1px solid rgba(255, 255, 255, 0.2)',
//     zIndex: 2,
//     position: 'relative'
//   },
//   title: {
//     fontSize: '28px',
//     fontWeight: '700',
//     color: '#333',
//     marginBottom: '10px',
//     background: 'linear-gradient(135deg, #667eea, #764ba2)',
//     WebkitBackgroundClip: 'text',
//     WebkitTextFillColor: 'transparent',
//     backgroundClip: 'text'
//   },
//   subtitle: {
//     color: '#666',
//     fontSize: '14px',
//     marginBottom: '30px',
//     lineHeight: '1.5'
//   },
//   inputGroup: {
//     position: 'relative',
//     marginBottom: '25px'
//   },
//   input: {
//     width: '100%',
//     padding: '15px 45px 15px 20px',
//     border: '2px solid #e1e5e9',
//     borderRadius: '12px',
//     fontSize: '16px',
//     transition: 'all 0.3s ease',
//     outline: 'none',
//     boxSizing: 'border-box',
//     backgroundColor: '#fff'
//   },
//   inputIcon: {
//     position: 'absolute',
//     right: '15px',
//     top: '50%',
//     transform: 'translateY(-50%)',
//     fontSize: '18px'
//   },
//   button: {
//     width: '100%',
//     padding: '15px',
//     backgroundColor: '#667eea',
//     color: 'white',
//     border: 'none',
//     borderRadius: '12px',
//     fontSize: '16px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease',
//     marginBottom: '15px',
//     boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
//   },
//   buttonDisabled: {
//     backgroundColor: '#a0a0a0',
//     cursor: 'not-allowed',
//     boxShadow: 'none'
//   },
//   loadingContent: {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     gap: '10px'
//   },
//   spinner: {
//     width: '18px',
//     height: '18px',
//     border: '2px solid transparent',
//     borderTop: '2px solid white',
//     borderRadius: '50%',
//     animation: 'spin 1s linear infinite'
//   },
//   backButton: {
//     width: '100%',
//     padding: '12px',
//     backgroundColor: 'transparent',
//     color: '#667eea',
//     border: '2px solid #667eea',
//     borderRadius: '12px',
//     fontSize: '14px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease'
//   }
// };

// // Add CSS for spinner animation
// const spinnerStyle = document.createElement('style');
// spinnerStyle.textContent = `
//   @keyframes spin {
//     0% { transform: rotate(0deg); }
//     100% { transform: rotate(360deg); }
//   }
// `;
// document.head.appendChild(spinnerStyle);

// export default ForgotPasswordPage;




// import React, { useState } from "react";
// import swal from "sweetalert";
// import { useNavigate } from "react-router-dom";

// const ForgotPasswordPage = () => {
//   const [step, setStep] = useState(1); // 1: Email, 2: OTP, 3: New Password
//   const [email, setEmail] = useState("");
//   const [otp, setOtp] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [resendCooldown, setResendCooldown] = useState(0);
//   const navigate = useNavigate();

//   // Handle sending OTP to email
//   const handleSendOTP = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//      // In your reset password function
//       const response = await fetch("http://127.0.0.1:5055/api/users/reset-password", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ 
//           email, 
//           otp, 
//           password: newPassword,
//           confirm_password: confirmPassword  // Add this
//         }),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         swal("Success", "OTP sent to your email! Check your inbox and spam folder.", "success");
//         setStep(2);
//         startResendCooldown();
//       } else {
//         swal("Error", data.error || "Failed to send OTP", "error");
//       }
//     } catch (err) {
//       swal("Error", "Server error. Please try again.", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle OTP verification
//   const handleVerifyOTP = async (e) => {
//     e.preventDefault();
//     if (otp.length !== 6) {
//       swal("Error", "Please enter a valid 6-digit OTP", "error");
//       return;
//     }
    
//     setLoading(true);
//     try {
//       const response = await fetch("http://127.0.0.1:5055/api/users/verify-otp", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email, otp }),
//       });
//       const data = await response.json();
//       if (response.ok && data.valid) {
//         swal("Success", "OTP verified successfully!", "success");
//         setStep(3);
//       } else {
//         swal("Error", data.error || "Invalid OTP", "error");
//       }
//     } catch (err) {
//       swal("Error", "Server error during OTP verification", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle password reset
//   const handleResetPassword = async (e) => {
//     e.preventDefault();
    
//     if (newPassword.length < 6) {
//       swal("Error", "Password must be at least 6 characters long", "error");
//       return;
//     }
    
//     if (newPassword !== confirmPassword) {
//       swal("Error", "Passwords do not match", "error");
//       return;
//     }
    
//     setLoading(true);
//     try {
//       const response = await fetch("http://127.0.0.1:5055/api/users/reset-password", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ 
//           email, 
//           otp, 
//           password: newPassword 
//         }),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         swal("Success", "Password reset successfully! You can now login with your new password.", "success");
//         navigate("/login");
//       } else {
//         swal("Error", data.error || "Failed to reset password", "error");
//       }
//     } catch (err) {
//       swal("Error", "Server error during password reset", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle resend OTP
//   const handleResendOTP = async () => {
//     if (resendCooldown > 0) return;
    
//     setLoading(true);
//     try {
//       const response = await fetch("http://127.0.0.1:5055/api/users/resend-otp", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email }),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         swal("Success", "New OTP sent to your email!", "success");
//         startResendCooldown();
//       } else {
//         swal("Error", data.error || "Failed to resend OTP", "error");
//       }
//     } catch (err) {
//       swal("Error", "Server error. Please try again.", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Start cooldown timer for resend OTP
//   const startResendCooldown = () => {
//     setResendCooldown(30);
//     const timer = setInterval(() => {
//       setResendCooldown((prev) => {
//         if (prev <= 1) {
//           clearInterval(timer);
//           return 0;
//         }
//         return prev - 1;
//       });
//     }, 1000);
//   };

//   // Go back to previous step
//   const handleBack = () => {
//     if (step === 1) {
//       navigate("/login");
//     } else {
//       setStep(step - 1);
//     }
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.background}>
//         <div style={styles.shape}></div>
//         <div style={styles.shape}></div>
//       </div>
      
//       <form onSubmit={
//         step === 1 ? handleSendOTP : 
//         step === 2 ? handleVerifyOTP : 
//         handleResetPassword
//       } style={styles.form}>
        
//         {/* Step Indicator */}
//         <div style={styles.stepIndicator}>
//           <div style={{...styles.step, ...(step >= 1 ? styles.stepActive : {})}}>1</div>
//           <div style={styles.stepLine}></div>
//           <div style={{...styles.step, ...(step >= 2 ? styles.stepActive : {})}}>2</div>
//           <div style={styles.stepLine}></div>
//           <div style={{...styles.step, ...(step >= 3 ? styles.stepActive : {})}}>3</div>
//         </div>

//         <h2 style={styles.title}>
//           {step === 1 && "Forgot Password?"}
//           {step === 2 && "Verify OTP"}
//           {step === 3 && "Reset Password"}
//         </h2>
        
//         <p style={styles.subtitle}>
//           {step === 1 && "Enter your email address and we'll send you an OTP"}
//           {step === 2 && "Enter the 6-digit OTP sent to your email"}
//           {step === 3 && "Enter your new password"}
//         </p>

//         {/* Step 1: Email Input */}
//         {step === 1 && (
//           <div style={styles.inputGroup}>
//             <input
//               type="email"
//               placeholder="Enter your registered email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//               style={styles.input}
//               disabled={loading}
//             />
//             <span style={styles.inputIcon}>📧</span>
//           </div>
//         )}

//         {/* Step 2: OTP Input */}
//         {step === 2 && (
//           <>
//             <div style={styles.inputGroup}>
//               <input
//                 type="text"
//                 placeholder="Enter 6-digit OTP"
//                 value={otp}
//                 onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
//                 required
//                 style={styles.input}
//                 disabled={loading}
//                 maxLength={6}
//               />
//               <span style={styles.inputIcon}>🔒</span>
//             </div>
            
//             <div style={styles.resendContainer}>
//               <button 
//                 type="button" 
//                 onClick={handleResendOTP}
//                 disabled={resendCooldown > 0 || loading}
//                 style={{
//                   ...styles.resendButton,
//                   ...((resendCooldown > 0 || loading) ? styles.resendButtonDisabled : {})
//                 }}
//               >
//                 {resendCooldown > 0 ? `Resend OTP in ${resendCooldown}s` : "Resend OTP"}
//               </button>
//             </div>
//           </>
//         )}

//         {/* Step 3: New Password Input */}
//         {step === 3 && (
//           <>
//             <div style={styles.inputGroup}>
//               <input
//                 type="password"
//                 placeholder="Enter new password"
//                 value={newPassword}
//                 onChange={(e) => setNewPassword(e.target.value)}
//                 required
//                 style={styles.input}
//                 disabled={loading}
//                 minLength={6}
//               />
//               <span style={styles.inputIcon}>🔑</span>
//             </div>
            
//             <div style={styles.inputGroup}>
//               <input
//                 type="password"
//                 placeholder="Confirm new password"
//                 value={confirmPassword}
//                 onChange={(e) => setConfirmPassword(e.target.value)}
//                 required
//                 style={styles.input}
//                 disabled={loading}
//                 minLength={6}
//               />
//               <span style={styles.inputIcon}>🔑</span>
//             </div>
            
//             {newPassword && confirmPassword && newPassword !== confirmPassword && (
//               <div style={styles.errorText}>Passwords do not match</div>
//             )}
            
//             {newPassword && newPassword.length < 6 && (
//               <div style={styles.errorText}>Password must be at least 6 characters</div>
//             )}
//           </>
//         )}

//         {/* Submit Button */}
//         <button 
//           type="submit" 
//           disabled={loading}
//           style={{
//             ...styles.button,
//             ...(loading ? styles.buttonDisabled : {})
//           }}
//         >
//           {loading ? (
//             <div style={styles.loadingContent}>
//               <div style={styles.spinner}></div>
//               {step === 1 && "Sending OTP..."}
//               {step === 2 && "Verifying OTP..."}
//               {step === 3 && "Resetting Password..."}
//             </div>
//           ) : (
//             step === 1 ? "Send OTP" :
//             step === 2 ? "Verify OTP" :
//             "Reset Password"
//           )}
//         </button>

//         {/* Back Button */}
//         <button 
//           type="button" 
//           onClick={handleBack}
//           style={styles.backButton}
//           disabled={loading}
//         >
//           ← Back {step === 1 ? "to Login" : ""}
//         </button>
//       </form>

//       {/* Add CSS for spinner animation */}
//       <style>
//         {`
//           @keyframes spin {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     minHeight: '100vh',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//     padding: '20px',
//     position: 'relative',
//     overflow: 'hidden'
//   },
//   background: {
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     zIndex: 1
//   },
//   shape: {
//     position: 'absolute',
//     borderRadius: '50%',
//     background: 'rgba(255, 255, 255, 0.1)',
//     width: '300px',
//     height: '300px',
//     top: '-100px',
//     left: '-100px',
//     ':nth-child(2)': {
//       width: '200px',
//       height: '200px',
//       bottom: '-50px',
//       right: '-50px',
//       top: 'auto',
//       left: 'auto'
//     }
//   },
//   form: {
//     backgroundColor: 'rgba(255, 255, 255, 0.95)',
//     padding: '40px',
//     borderRadius: '20px',
//     boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
//     width: '100%',
//     maxWidth: '400px',
//     textAlign: 'center',
//     backdropFilter: 'blur(10px)',
//     border: '1px solid rgba(255, 255, 255, 0.2)',
//     zIndex: 2,
//     position: 'relative'
//   },
//   stepIndicator: {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     marginBottom: '30px'
//   },
//   step: {
//     width: '35px',
//     height: '35px',
//     borderRadius: '50%',
//     backgroundColor: '#e1e5e9',
//     color: '#666',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontWeight: '600',
//     fontSize: '14px',
//     transition: 'all 0.3s ease'
//   },
//   stepActive: {
//     backgroundColor: '#667eea',
//     color: 'white',
//     boxShadow: '0 4px 10px rgba(102, 126, 234, 0.3)'
//   },
//   stepLine: {
//     width: '40px',
//     height: '2px',
//     backgroundColor: '#e1e5e9',
//     margin: '0 5px'
//   },
//   title: {
//     fontSize: '28px',
//     fontWeight: '700',
//     color: '#333',
//     marginBottom: '10px',
//     background: 'linear-gradient(135deg, #667eea, #764ba2)',
//     WebkitBackgroundClip: 'text',
//     WebkitTextFillColor: 'transparent',
//     backgroundClip: 'text'
//   },
//   subtitle: {
//     color: '#666',
//     fontSize: '14px',
//     marginBottom: '30px',
//     lineHeight: '1.5'
//   },
//   inputGroup: {
//     position: 'relative',
//     marginBottom: '20px'
//   },
//   input: {
//     width: '100%',
//     padding: '15px 45px 15px 20px',
//     border: '2px solid #e1e5e9',
//     borderRadius: '12px',
//     fontSize: '16px',
//     transition: 'all 0.3s ease',
//     outline: 'none',
//     boxSizing: 'border-box',
//     backgroundColor: '#fff'
//   },
//   inputIcon: {
//     position: 'absolute',
//     right: '15px',
//     top: '50%',
//     transform: 'translateY(-50%)',
//     fontSize: '18px'
//   },
//   resendContainer: {
//     marginBottom: '20px'
//   },
//   resendButton: {
//     backgroundColor: 'transparent',
//     color: '#667eea',
//     border: '2px solid #667eea',
//     borderRadius: '8px',
//     padding: '8px 16px',
//     fontSize: '14px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease'
//   },
//   resendButtonDisabled: {
//     color: '#a0a0a0',
//     borderColor: '#a0a0a0',
//     cursor: 'not-allowed'
//   },
//   errorText: {
//     color: '#e74c3c',
//     fontSize: '14px',
//     textAlign: 'left',
//     marginTop: '-10px',
//     marginBottom: '15px'
//   },
//   button: {
//     width: '100%',
//     padding: '15px',
//     backgroundColor: '#667eea',
//     color: 'white',
//     border: 'none',
//     borderRadius: '12px',
//     fontSize: '16px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease',
//     marginBottom: '15px',
//     boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
//   },
//   buttonDisabled: {
//     backgroundColor: '#a0a0a0',
//     cursor: 'not-allowed',
//     boxShadow: 'none'
//   },
//   loadingContent: {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     gap: '10px'
//   },
//   spinner: {
//     width: '18px',
//     height: '18px',
//     border: '2px solid transparent',
//     borderTop: '2px solid white',
//     borderRadius: '50%',
//     animation: 'spin 1s linear infinite'
//   },
//   backButton: {
//     width: '100%',
//     padding: '12px',
//     backgroundColor: 'transparent',
//     color: '#667eea',
//     border: '2px solid #667eea',
//     borderRadius: '12px',
//     fontSize: '14px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease'
//   }
// };

// export default ForgotPasswordPage;




import React, { useState } from "react";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";

const ForgotPasswordPage = () => {
  const [step, setStep] = useState(1); // 1: Email, 2: OTP, 3: New Password
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(0);
  const navigate = useNavigate();

  // Handle sending OTP to email
  const handleSendOTP = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch("https://dairy.server.statify.co.ke/api/users/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      if (response.ok) {
        swal("Success", "OTP sent to your email! Check your inbox and terminal for the code.", "success");
        setStep(2);
        startResendCooldown();
      } else {
        // For security, backend doesn't reveal if email exists, so we show success message anyway
        swal("Success", "If the email exists in our system, an OTP has been sent. Check your email and terminal.", "success");
        setStep(2);
        startResendCooldown();
      }
    } catch (err) {
      swal("Error", "Server error. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  // Handle OTP verification
  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    if (otp.length !== 6) {
      swal("Error", "Please enter a valid 6-digit OTP", "error");
      return;
    }
    
    setLoading(true);
    try {
      const response = await fetch("https://dairy.server.statify.co.ke/api/users/verify-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp }),
      });
      const data = await response.json();
      if (response.ok) {
        swal("Success", "OTP verified successfully!", "success");
        setStep(3);
      } else {
        swal("Error", data.error || "Invalid OTP", "error");
      }
    } catch (err) {
      swal("Error", "Server error during OTP verification", "error");
    } finally {
      setLoading(false);
    }
  };

  // Handle password reset
  const handleResetPassword = async (e) => {
    e.preventDefault();
    
    if (newPassword.length < 6) {
      swal("Error", "Password must be at least 6 characters long", "error");
      return;
    }
    
    if (newPassword !== confirmPassword) {
      swal("Error", "Passwords do not match", "error");
      return;
    }
    
    setLoading(true);
    try {
      const response = await fetch("https://dairy.server.statify.co.ke/api/users/reset-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          email, 
          otp, 
          password: newPassword,
          confirm_password: confirmPassword  // Added confirm_password
        }),
      });
      const data = await response.json();
      if (response.ok) {
        swal("Success", "Password reset successfully! You can now login with your new password.", "success");
        navigate("/login");
      } else {
        swal("Error", data.error || "Failed to reset password", "error");
      }
    } catch (err) {
      swal("Error", "Server error during password reset", "error");
    } finally {
      setLoading(false);
    }
  };

  // Handle resend OTP
  const handleResendOTP = async () => {
    if (resendCooldown > 0) return;
    
    setLoading(true);
    try {
      const response = await fetch("https://dairy.server.statify.co.ke/api/users/resend-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      if (response.ok) {
        swal("Success", "New OTP sent to your email!", "success");
        startResendCooldown();
      } else {
        swal("Error", data.error || "Failed to resend OTP", "error");
      }
    } catch (err) {
      swal("Error", "Server error. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  // Start cooldown timer for resend OTP
  const startResendCooldown = () => {
    setResendCooldown(30);
    const timer = setInterval(() => {
      setResendCooldown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  // Go back to previous step
  const handleBack = () => {
    if (step === 1) {
      navigate("/login");
    } else {
      setStep(step - 1);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.background}>
        <div style={styles.shape}></div>
        <div style={styles.shape}></div>
      </div>
      
      <form onSubmit={
        step === 1 ? handleSendOTP : 
        step === 2 ? handleVerifyOTP : 
        handleResetPassword
      } style={styles.form}>
        
        {/* Step Indicator */}
        <div style={styles.stepIndicator}>
          <div style={{...styles.step, ...(step >= 1 ? styles.stepActive : {})}}>
            {step > 1 ? "✓" : "1"}
          </div>
          <div style={styles.stepLine}></div>
          <div style={{...styles.step, ...(step >= 2 ? styles.stepActive : {})}}>
            {step > 2 ? "✓" : "2"}
          </div>
          <div style={styles.stepLine}></div>
          <div style={{...styles.step, ...(step >= 3 ? styles.stepActive : {})}}>3</div>
        </div>

        <h2 style={styles.title}>
          {step === 1 && "Forgot Password?"}
          {step === 2 && "Verify OTP"}
          {step === 3 && "Reset Password"}
        </h2>
        
        <p style={styles.subtitle}>
          {step === 1 && "Enter your email address and we'll send you an OTP"}
          {step === 2 && "Enter the 6-digit OTP sent to your email"}
          {step === 3 && "Enter your new password"}
        </p>

        {/* Development Note - Only show in development */}
        {process.env.NODE_ENV === 'development' && step === 2 && (
          <div style={styles.devNote}>
            💡 <strong>Development Note:</strong> Check your terminal for OTP if email fails
          </div>
        )}

        {/* Step 1: Email Input */}
        {step === 1 && (
          <div style={styles.inputGroup}>
            <input
              type="email"
              placeholder="Enter your registered email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={styles.input}
              disabled={loading}
            />
            <span style={styles.inputIcon}>📧</span>
          </div>
        )}

        {/* Step 2: OTP Input */}
        {step === 2 && (
          <>
            <div style={styles.inputGroup}>
              <input
                type="text"
                placeholder="Enter 6-digit OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                required
                style={styles.input}
                disabled={loading}
                maxLength={6}
              />
              <span style={styles.inputIcon}>🔢</span>
            </div>
            
            <div style={styles.otpInfo}>
              <div style={styles.otpTimer}>
                ⏰ OTP expires in 15 minutes
              </div>
            </div>
            
            <div style={styles.resendContainer}>
              <button 
                type="button" 
                onClick={handleResendOTP}
                disabled={resendCooldown > 0 || loading}
                style={{
                  ...styles.resendButton,
                  ...((resendCooldown > 0 || loading) ? styles.resendButtonDisabled : {})
                }}
              >
                {resendCooldown > 0 ? `Resend OTP in ${resendCooldown}s` : "Resend OTP"}
              </button>
            </div>
          </>
        )}

        {/* Step 3: New Password Input */}
        {step === 3 && (
          <>
            <div style={styles.inputGroup}>
              <input
                type="password"
                placeholder="Enter new password (min 6 characters)"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                style={{
                  ...styles.input,
                  ...(newPassword && newPassword.length < 6 ? styles.inputError : {}),
                  ...(newPassword && newPassword.length >= 6 ? styles.inputSuccess : {})
                }}
                disabled={loading}
                minLength={6}
              />
              <span style={styles.inputIcon}>🔑</span>
              {newPassword && (
                <div style={styles.passwordStrength}>
                  {newPassword.length < 6 ? (
                    <span style={styles.weakPassword}>Weak - at least 6 characters required</span>
                  ) : (
                    <span style={styles.strongPassword}>Strong password ✓</span>
                  )}
                </div>
              )}
            </div>
            
            <div style={styles.inputGroup}>
              <input
                type="password"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                style={{
                  ...styles.input,
                  ...(confirmPassword && newPassword !== confirmPassword ? styles.inputError : {}),
                  ...(confirmPassword && newPassword === confirmPassword && newPassword.length >= 6 ? styles.inputSuccess : {})
                }}
                disabled={loading}
                minLength={6}
              />
              <span style={styles.inputIcon}>🔒</span>
              {confirmPassword && newPassword !== confirmPassword && (
                <div style={styles.passwordMismatch}>Passwords do not match</div>
              )}
              {confirmPassword && newPassword === confirmPassword && newPassword.length >= 6 && (
                <div style={styles.passwordMatch}>Passwords match ✓</div>
              )}
            </div>
          </>
        )}

        {/* Submit Button */}
        <button 
          type="submit" 
          disabled={loading || 
            (step === 2 && otp.length !== 6) || 
            (step === 3 && (newPassword.length < 6 || newPassword !== confirmPassword))
          }
          style={{
            ...styles.button,
            ...(loading ? styles.buttonDisabled : {}),
            ...((step === 2 && otp.length !== 6) || 
                (step === 3 && (newPassword.length < 6 || newPassword !== confirmPassword)) 
                ? styles.buttonDisabled : {})
          }}
        >
          {loading ? (
            <div style={styles.loadingContent}>
              <div style={styles.spinner}></div>
              {step === 1 && "Sending OTP..."}
              {step === 2 && "Verifying OTP..."}
              {step === 3 && "Resetting Password..."}
            </div>
          ) : (
            step === 1 ? "Send OTP" :
            step === 2 ? "Verify OTP" :
            "Reset Password"
          )}
        </button>

        {/* Back Button */}
        <button 
          type="button" 
          onClick={handleBack}
          style={styles.backButton}
          disabled={loading}
        >
          ← Back {step === 1 ? "to Login" : ""}
        </button>

        {/* Help Text */}
        {step === 1 && (
          <div style={styles.helpText}>
            Can't find the email? Check your spam folder or contact support.
          </div>
        )}
      </form>

      {/* Add CSS for spinner animation */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    padding: '20px',
    position: 'relative',
    overflow: 'hidden'
  },
  background: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1
  },
  shape: {
    position: 'absolute',
    borderRadius: '50%',
    background: 'rgba(255, 255, 255, 0.1)',
    width: '300px',
    height: '300px',
    top: '-100px',
    left: '-100px',
    ':nth-child(2)': {
      width: '200px',
      height: '200px',
      bottom: '-50px',
      right: '-50px',
      top: 'auto',
      left: 'auto'
    }
  },
  form: {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    padding: '40px',
    borderRadius: '20px',
    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
    width: '100%',
    maxWidth: '420px',
    textAlign: 'center',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    zIndex: 2,
    position: 'relative'
  },
  stepIndicator: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '25px'
  },
  step: {
    width: '35px',
    height: '35px',
    borderRadius: '50%',
    backgroundColor: '#e1e5e9',
    color: '#666',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '600',
    fontSize: '14px',
    transition: 'all 0.3s ease'
  },
  stepActive: {
    backgroundColor: '#667eea',
    color: 'white',
    boxShadow: '0 4px 10px rgba(102, 126, 234, 0.3)'
  },
  stepLine: {
    width: '50px',
    height: '2px',
    backgroundColor: '#e1e5e9',
    margin: '0 5px'
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#333',
    marginBottom: '10px',
    background: 'linear-gradient(135deg, #667eea, #764ba2)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text'
  },
  subtitle: {
    color: '#666',
    fontSize: '14px',
    marginBottom: '25px',
    lineHeight: '1.5'
  },
  devNote: {
    backgroundColor: '#fff3cd',
    border: '1px solid #ffeaa7',
    borderRadius: '8px',
    padding: '10px',
    fontSize: '12px',
    color: '#856404',
    marginBottom: '20px',
    textAlign: 'left'
  },
  inputGroup: {
    position: 'relative',
    marginBottom: '20px'
  },
  input: {
    width: '100%',
    padding: '15px 45px 15px 20px',
    border: '2px solid #e1e5e9',
    borderRadius: '12px',
    fontSize: '16px',
    transition: 'all 0.3s ease',
    outline: 'none',
    boxSizing: 'border-box',
    backgroundColor: '#fff'
  },
  inputError: {
    borderColor: '#e74c3c'
  },
  inputSuccess: {
    borderColor: '#27ae60'
  },
  inputIcon: {
    position: 'absolute',
    right: '15px',
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: '18px'
  },
  otpInfo: {
    marginBottom: '15px'
  },
  otpTimer: {
    fontSize: '14px',
    color: '#666',
    fontWeight: '500'
  },
  resendContainer: {
    marginBottom: '20px'
  },
  resendButton: {
    backgroundColor: 'transparent',
    color: '#667eea',
    border: '2px solid #667eea',
    borderRadius: '8px',
    padding: '10px 16px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    width: '100%'
  },
  resendButtonDisabled: {
    color: '#a0a0a0',
    borderColor: '#a0a0a0',
    cursor: 'not-allowed'
  },
  passwordStrength: {
    fontSize: '12px',
    textAlign: 'left',
    marginTop: '5px',
    paddingLeft: '5px'
  },
  weakPassword: {
    color: '#e74c3c'
  },
  strongPassword: {
    color: '#27ae60'
  },
  passwordMismatch: {
    color: '#e74c3c',
    fontSize: '12px',
    textAlign: 'left',
    marginTop: '5px',
    paddingLeft: '5px'
  },
  passwordMatch: {
    color: '#27ae60',
    fontSize: '12px',
    textAlign: 'left',
    marginTop: '5px',
    paddingLeft: '5px'
  },
  button: {
    width: '100%',
    padding: '15px',
    backgroundColor: '#667eea',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    marginBottom: '15px',
    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
  },
  buttonDisabled: {
    backgroundColor: '#a0a0a0',
    cursor: 'not-allowed',
    boxShadow: 'none'
  },
  loadingContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px'
  },
  spinner: {
    width: '18px',
    height: '18px',
    border: '2px solid transparent',
    borderTop: '2px solid white',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  },
  backButton: {
    width: '100%',
    padding: '12px',
    backgroundColor: 'transparent',
    color: '#667eea',
    border: '2px solid #667eea',
    borderRadius: '12px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    marginBottom: '10px'
  },
  helpText: {
    fontSize: '12px',
    color: '#666',
    marginTop: '10px'
  }
};

export default ForgotPasswordPage;